import apiHttp from './apiHttp.js'
import storage from '../utils/storage'


function getCurLang(state) {
    //console.log('-----getCurLang', state)
    return _.get(state, 'curLang', 'en_US');
}

function getCurSite(state) {
    return _.get(state, 'curSite', false);
    //return storage.get('cur-site')
}

export default {
    test(url, params) {
        apiHttp.test(url, params);
    },
    postPaymentPageLog(data, state) {
        return new Promise((resolve, reject) => {
            apiHttp
                .post('/api/v2/client/visitPaymentPageLog', data, false, state)
                .then(rs => {
                    resolve(rs.data)
                })
                .catch(err => {
                    console.error([
                        'postPaymentPageLog error', err
                    ])
                    reject(err)
                })
        });
    },
    getApplyCreateTIMGroup(paramString, state) {
        return new Promise((resolve, reject) => {

            apiHttp
                .get(`/api/v2/client/applyCreateTIMGroup?${paramString}`, false, state)
                .then(rs => {
                    resolve(rs.data)
                })
                .catch(err => {
                    console.error([
                        'getApplyCreateTIMGroup error', err
                    ])
                    reject(err)
                })
        });
    },

}
